import React, { useState, useRef } from "react";
import { useQuery, gql, useApolloClient } from "@apollo/client";
import {
  Clear as ClearIcon,
  AddCircle as AddCircleIcon,
  Cancel as CancelIcon,
  KeyboardReturn as KeyboardReturnIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import {
  TextField,
  IconButton,
  Typography,
  Stack,
  Button,
  InputAdornment,
} from "@mui/material";
import { onCreate } from "../function/onCreate";

import { onDelete } from "../function/onDelete";

const query = gql`
  query NotesByItemAndType(
    $itemID: ID!
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notesByItemAndType(
      itemID: $itemID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        itemID
        message
        createdBy
        groupToRead
        groupToEdit
        groupToDelete
        createdAt
        updatedAt
        date @client
      }
      nextToken
    }
  }
`;

const createNote = /* GraphQL */ `
  mutation CreateNote(
    $input: CreateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    createNote(input: $input, condition: $condition) {
      id
      type
      itemID
      message
      createdBy
      groupToRead
      groupToEdit
      groupToDelete
      createdAt
      updatedAt
    }
  }
`;

const deleteNote = /* GraphQL */ `
  mutation DeleteNote(
    $input: DeleteNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    deleteNote(input: $input, condition: $condition) {
      id
      itemID
      message
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export default function Note({ itemID }) {
  const client = useApolloClient();

  const [isAddingNote, setIsAddingNote] = useState(false);

  let { data } = useQuery(
    gql`
      ${query}
    `,
    {
      variables: { itemID, type: { eq: "COMMENT" } },
      fetchPolicy: "network-only",
    }
  );

  data = data?.notesByItemAndType?.items.sort((a, b) =>
    a.createdAt > b.createdAt ? 1 : -1
  );

  if (!itemID) return null;

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography flexGrow={1} bgcolor="yellow" p={1} variant="h6">
          NOTES
        </Typography>

        {!isAddingNote ? (
          <Button
            // disabled={isAddingNote}
            size="small"
            color="secondary"
            sx={
              {
                // color: "purple",
                // alignItems: "flex-start",
                // alignSelf: "start",
                // justifyContent: "flex-start",
              }
            }
            variant="contained"
            startIcon={<AddCircleIcon />}
            onClick={() => setIsAddingNote(true)}
          >
            add note
          </Button>
        ) : (
          <AddNote
            itemID={itemID}
            setIsAddingNote={setIsAddingNote}
            client={client}
          />
        )}
      </Stack>

      <Stack direction="column">
        {data?.map((x, i) => (
          <Stack key={i} alignItems="center" direction="row">
            <IconButton
              onClick={async () => {
                try {
                  await onDelete({
                    input: { id: x.id },
                    mutation: deleteNote,
                    // updateCacheFields: ["listEntities"],
                    client,
                  });
                } catch (err) {
                  console.log("error deleting note", err);
                }
              }}
            >
              <ClearIcon />
            </IconButton>
            <MessageItem item={x} />
          </Stack>
        ))}
        {(!data || data.length === 0) && <Typography p={2}>no note</Typography>}
      </Stack>
    </Stack>
  );
}

function AddNote({ itemID, setIsAddingNote, client }) {
  const inputRef = useRef();

  const [value, setValue] = useState();

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <TextField
      inputRef={inputRef}
      id="outlined-multiline-flexible"
      label="Comment"
      autoFocus
      sx={{ width: 800 }}
      multiline
      maxRows={4}
      value={value}
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <Stack direction="row">
              <IconButton
                // aria-label="toggle password visibility"
                onClick={() => {
                  setValue("");
                  inputRef.current.focus();
                }}
                // onMouseDown={handleMouseDownPassword}
                // edge="end"
              >
                <CancelIcon color="error" />
              </IconButton>
              <IconButton
                onClick={async () => {
                  const input = {
                    itemID: itemID,
                    message: value,
                    type: "COMMENT",
                  };

                  const NoteFragment = /* GraphQL */ `
                    fragment NewNote on Note {
                      id
                    }
                  `;

                  await onCreate({
                    input,
                    mutation: createNote,
                    fragment: NoteFragment,
                    updateCacheFields: [],
                    client,
                    refetchQueries: ["NotesByItemAndType"],
                  });
                  setValue("");
                  setIsAddingNote(false);
                }}
                // aria-label="toggle password visibility"
                // onClick={handleClickShowPassword}
                // onMouseDown={handleMouseDownPassword}
                // edge="end"
              >
                <CheckCircleIcon color="success" />
              </IconButton>
              <IconButton
                // aria-label="toggle password visibility"
                onClick={() => setIsAddingNote(false)}
                // onMouseDown={handleMouseDownPassword}
                // edge="end"
              >
                <KeyboardReturnIcon color="primary" />
              </IconButton>
            </Stack>
          </InputAdornment>
        ),
      }}
    />
  );
}

function MessageItem({ item }) {
  return (
    <Stack
      width="100%"
      direction="row"
      justifyContent="space-between"
      bgcolor="grey.200"
      p={1}
      borderRadius={1}
      spacing={3}
    >
      <Typography sx={{ fontStyle: "italic" }} variant="body1">
        {item.message}
      </Typography>

      <Stack direction="row">
        <Typography width={100} sx={{ fontStyle: "italic" }} variant="body2">
          {item.date}
        </Typography>
        <Typography width={200} sx={{ fontStyle: "italic" }} variant="body2">
          {item.createdBy}
        </Typography>
      </Stack>
    </Stack>
  );
}
